/**
 * Include each locale json file and return it in an object
 * that can be consumed by i18n
 */

import json_en from '../../../res/locales/en/nobundle-viewports.loc.json';

import json_en_GB from '../../../res/locales/en-GB/nobundle-viewports.loc.json';
import json_cs from '../../../res/locales/cs/nobundle-viewports.loc.json';
import json_de from '../../../res/locales/de/nobundle-viewports.loc.json';
import json_es from '../../../res/locales/es/nobundle-viewports.loc.json';
import json_fr from '../../../res/locales/fr/nobundle-viewports.loc.json';
import json_fr_CA from '../../../res/locales/fr-CA/nobundle-viewports.loc.json';
import json_it from '../../../res/locales/it/nobundle-viewports.loc.json';
import json_ja from '../../../res/locales/ja/nobundle-viewports.loc.json';
import json_ko from '../../../res/locales/ko/nobundle-viewports.loc.json';
import json_pl from '../../../res/locales/pl/nobundle-viewports.loc.json';
import json_pt_BR from '../../../res/locales/pt-BR/nobundle-viewports.loc.json';
import json_ru from '../../../res/locales/ru/nobundle-viewports.loc.json';
import json_tr from '../../../res/locales/tr/nobundle-viewports.loc.json';
import json_zh_Hans from '../../../res/locales/zh-Hans/nobundle-viewports.loc.json';
import json_zh_Hant from '../../../res/locales/zh-Hant/nobundle-viewports.loc.json';
import json_zh_HK from '../../../res/locales/zh-HK/nobundle-viewports.loc.json';
import json_nl from '../../../res/locales/nl/nobundle-viewports.loc.json';
import json_sv from '../../../res/locales/sv/nobundle-viewports.loc.json';
import json_da from '../../../res/locales/da/nobundle-viewports.loc.json';
import json_no from '../../../res/locales/no/nobundle-viewports.loc.json';

export const locales = {
    en: json_en,
    'en-GB': json_en_GB,
    cs: json_cs,
    de: json_de,
    es: json_es,
    fr: json_fr,
    "fr-CA": json_fr_CA,
    it: json_it,
    ja: json_ja,
    ko: json_ko,
    pl: json_pl,
    "pt-BR": json_pt_BR,
    ru: json_ru,
    tr: json_tr,
    "zh-Hans": json_zh_Hans,
    "zh-Hant": json_zh_Hant,
    "zh-HK": json_zh_HK,
    nl: json_nl,
    sv: json_sv,
    da: json_da,
    no: json_no,
};
